import { AxiosError } from "axios";

export function getBufferErrorMessage(error) {
  let errorMessage = "";
  if (error instanceof AxiosError && error?.response?.data) {
    const data = JSON.parse(new TextDecoder().decode(error.response.data));
    const errors = data?.errors;
    if (Array.isArray(errors) && errors[0]?.message) {
      errorMessage = errors[0].message;
    } else {
      errorMessage = data?.message;
    }
  } else {
    errorMessage = "Something went wrong. Please try again";
  }
  return errorMessage;
}

export function getErrorMessage(error) {
  let errorMessage = "";
  if (error instanceof AxiosError && error?.response?.data) {
    const errors = error?.response?.data?.errors;
    if (Array.isArray(errors) && errors[0]?.message) {
      errorMessage = errors[0]?.message;
    } else {
      errorMessage = error?.response?.data?.message;
    }
  } else {
    errorMessage = "Something went wrong. Please try again";
  }
  return errorMessage;
}
